//公共

/**
 * 更新routerview滑动方向
 * forward前进-向左滑动
 * reverse后退-向右滑动
 */
export const UPDATE_DIRECTION = "UPDATE_DIRECTION";

export const UPDATE_INCLUDE_PAGE = "UPDATE_INCLUDE_PAGE"; // 更新routerview缓存页面

export const UPDATE_LOAD_SHOW = "UPDATE_LOAD_SHOW"; // 更新加载动画是否显示

export const UPDATE_LOAD_TEXT = "UPDATE_LOAD_TEXT"; // 更新加载动画显示文本

export const UPDATE_LOAD_SHOW_LEVEL = "UPDATE_LOAD_SHOW_LEVEL"; // 更新加载动画是层级显示

export const ADD_LOAD_SHOW_LEVEL = "ADD_LOAD_SHOW_LEVEL"; // 增加加载动画层级显示

export const REDUCE_LOAD_SHOW_LEVEL = "REDUCE_LOAD_SHOW_LEVEL"; // 减少加载动画层级显示

export const RESET_LOAD_SHOW_LEVEL = "RESET_LOAD_SHOW_LEVEL"; // 加载动画层级置0

export const ADD_NEW_QUICK_SIGN_FILES = "ADD_NEW_QUICK_SIGN_FILES" //

export const ADD_SOURCE_FLAG = "actionSourceFlag" //

